import { DataSyncReconnectionConfig } from '../integrations/DataSync/DataSyncReconnectionConfig';
import { DashworksReconnectionConfig } from '../integrations/Dashworks/DashworksReconnectionConfig';
import { McpReconnectionConfig } from '../integrations/Mcp/McpReconnectionConfig';
import { getReconnectionConfigByAppId } from '../reconnectionConfigs';
import { OAuthReconnectionConfig } from '../integrations/OAuthIntegrations/OAuthReconnectionConfig';
import { UnifiedAccReconnectionConfig } from '../integrations/UnifiedAccApps/UnifiedAccReconnectionConfig';

export const getReconnectionConfig = ({
  appId,
  isDataSyncApp,
  isDashworksApp,
  isMcpSupportedApp,
  isUnifiedAccountSupportedApp,
  hasUrl,
}: {
  appId?: number;
  isDataSyncApp: boolean;
  isDashworksApp: boolean;
  isMcpSupportedApp: boolean;
  isUnifiedAccountSupportedApp: boolean;
  hasUrl: boolean;
}) => {
  const reconnectionConfig = appId ? getReconnectionConfigByAppId(appId) : null;

  if (isUnifiedAccountSupportedApp) {
    return UnifiedAccReconnectionConfig;
  } else if (reconnectionConfig) {
    return reconnectionConfig;
  } else if (isDataSyncApp) {
    return DataSyncReconnectionConfig;
  } else if (isDashworksApp) {
    return DashworksReconnectionConfig;
  } else if (isMcpSupportedApp) {
    return McpReconnectionConfig;
  } else if (hasUrl) {
    return OAuthReconnectionConfig;
  } else {
    return null;
  }
};
